module.exports = "./img/logo.b96028a6.svg";